import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function ReviewSection() {
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [reviewText, setReviewText] = useState('');
  const [name, setName] = useState('');
  const [reviews, setReviews] = useState<{
    name: string;
    text: string;
    rating: number;
  }[]>([]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (rating === 0 || !reviewText || !name) return;
    setReviews([{
      name,
      text: reviewText,
      rating
    }, ...reviews]);
    setRating(0);
    setReviewText('');
    setName('');
  };
  return <section className="py-10 px-4 bg-navy-900 relative border-t border-white/5" data-id="element-282">
      <div className="max-w-3xl mx-auto" data-id="element-283">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-284">
          <h2 className="text-4xl md:text-5xl font-bebas text-white mb-4" data-id="element-285">
            ¿Ya tenés tu mazo? ¡Dejá tu reseña!
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy-800 p-6 md:p-8 rounded-2xl border border-white/10 mb-12" data-id="element-286">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-287">
            <div data-id="element-288">
              <label className="block text-white/80 mb-2 text-sm" data-id="element-289">
                Tu calificación
              </label>
              <div className="flex gap-2" data-id="element-290">
                {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" onClick={() => setRating(star)} onMouseEnter={() => setHoverRating(star)} onMouseLeave={() => setHoverRating(0)} className="focus:outline-none transition-transform hover:scale-110" data-id="element-291">
                    <Star className={`w-8 h-8 ${star <= (hoverRating || rating) ? 'text-gold fill-gold' : 'text-white/20'}`} data-id="element-292" />
                  </button>)}
              </div>
            </div>

            <div data-id="element-293">
              <label htmlFor="name" className="block text-white/80 mb-2 text-sm" data-id="element-294">
                Tu nombre
              </label>
              <input id="name" type="text" value={name} onChange={e => setName(e.target.value)} className="w-full bg-navy-900 border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold/50 transition-colors" placeholder="Ej: Martín S." required data-id="element-295" />
            </div>

            <div data-id="element-296">
              <label htmlFor="review" className="block text-white/80 mb-2 text-sm" data-id="element-297">
                Tu reseña
              </label>
              <textarea id="review" value={reviewText} onChange={e => setReviewText(e.target.value)} rows={4} className="w-full bg-navy-900 border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold/50 transition-colors resize-none" placeholder="¿Qué te pareció el mazo? ¿Cómo quedó impreso?" required data-id="element-298" />
            </div>

            <button type="submit" disabled={rating === 0 || !reviewText || !name} className="w-full py-4 bg-gold text-navy-900 font-bold text-lg rounded-lg transition-transform hover:scale-[1.02] active:scale-[0.98] disabled:opacity-50 disabled:hover:scale-100 disabled:cursor-not-allowed" data-id="element-299">
              PUBLICAR RESEÑA
            </button>
          </form>
        </motion.div>

        {reviews.length > 0 && <div className="space-y-4" data-id="element-300">
            <h3 className="text-2xl font-bebas text-white mb-6" data-id="element-301">
              Reseñas recientes
            </h3>
            {reviews.map((rev, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="bg-navy-800 p-6 rounded-xl border border-white/5" data-id="element-302">
                <div className="flex gap-1 mb-3" data-id="element-303">
                  {[...Array(5)].map((_, i) => <Star key={i} className={`w-4 h-4 ${i < rev.rating ? 'text-gold fill-gold' : 'text-white/20'}`} data-id="element-304" />)}
                </div>
                <p className="text-white/90 mb-3" data-id="element-305">"{rev.text}"</p>
                <span className="text-white/50 text-sm font-medium" data-id="element-306">
                  {rev.name}
                </span>
              </motion.div>)}
          </div>}
      </div>
    </section>;
}